import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Dropdown,
  Card,
  Badge,
  Col,
  Row,
  Table,
} from "react-bootstrap";
import {
  Formik,
  Field,
  Form as FormikForm,
  ErrorMessage,
  FieldArray,
} from "formik";
import * as Yup from "yup";
import PageTitle from "../layouts/PageTitle";
import {
  changeRequestUserPlan,
  deleteRequestUserPlan,
  deleteSUBSCRIPTION,
  getNEWUSERS,
  getPackage,
  getPackageStats,
  getSUBSCRIPTION,
  postCombinedPackage,
  postSUBSCRIPTION,
  putCombinedPackage,
  updatetSUBSCRIPTION,
  getWhatsAppPackage,
  postWhatsAppPackage,
  putWhatsAppPackage,
  deleteWhatsAppPackage,
} from "../../services/UserServices/UserService";
import toast from "react-hot-toast";
import Select from "react-select";
import Pagination from "../components/Pagination";
import { debounce, set } from "lodash";
import { useNavigate } from "react-router-dom";
import {
  Package as PackageIcon,
  Pencil,
  MessageCircle,
  Check,
  MoreVertical,
  Calendar,
  Trash2,
} from "lucide-react";
import PageContentLoader from "../components/TableLoader";

const formatCurrency = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return value ?? "—";
  return num.toLocaleString("en-IN");
};

const resolveIncludedPlans = (pkg, subscriptionPlansList = []) => {
  const list =
    pkg?.combinedPackages?.length > 0
      ? pkg.combinedPackages
      : pkg?.plans?.length > 0
        ? pkg.plans
        : pkg?.partnerPackages;

  if (!list?.length) return [];

  return list.map((item, idx) => {
    let displayName = "";
    let limitVal =
      item?.hostLimit !== undefined && item?.hostLimit !== null ? item.hostLimit : 0;

    if (typeof item === "object" && item !== null) {
      const targetId =
        (typeof item.planId === "object" ? item.planId?._id : item.planId) ||
        (typeof item.packageId === "object" ? item.packageId?._id : item.packageId) ||
        item._id;

      const matched = subscriptionPlansList?.find((p) => (p._id || p.id) === targetId);
      displayName =
        matched?.name ||
        item.planId?.name ||
        item.packageId?.name ||
        item.name ||
        subscriptionPlansList[idx]?.name ||
        "Plan";
    } else {
      const matched = subscriptionPlansList?.find((p) => (p._id || p.id) === item);
      displayName = matched?.name || subscriptionPlansList[idx]?.name || String(item);
    }

    return { displayName, limitVal };
  });
};

const PartnerPackageCard = ({ pkg, subscriptionPlansList, onEdit, onDelete }) => {
  const included = resolveIncludedPlans(pkg, subscriptionPlansList);
  const totalWeddings =
    included.reduce((sum, plan) => sum + Number(plan.limitVal || 0), 0) ||
    pkg?.totalHostLimit ||
    0;

  return (
    <div className="col-lg-4 col-md-6 d-flex">
      <article className="qx-subscription-card qx-partner-package-card flex-fill d-flex flex-column justify-content-between p-3.5" style={{ borderRadius: "14px", border: "1px solid #e2e8f0", backgroundColor: "#ffffff" }}>
        <div>
          <div className="qx-subscription-card__header pb-3 mb-3 border-bottom d-flex align-items-start justify-content-between">
            <div className="qx-subscription-card__title-wrap">
              <h3 className="qx-subscription-card__name mb-1.5" style={{ fontSize: "1.15rem", fontWeight: "700", color: "#0f172a" }}>
                {pkg?.name || "Untitled"}
              </h3>
              <div className="d-flex align-items-center gap-2">
                <span
                  className="badge  border px-2.5 py-1.5 fw-bold"
                  style={{ fontSize: "0.82rem", borderRadius: "6px", color: "#334155", backgroundColor: "#f8fafc" }}
                >
                  ₹{formatCurrency(pkg?.price)}
                </span>
              </div>
            </div>
            <Dropdown align="end">
              <Dropdown.Toggle variant="" className="qx-action-toggle i-false p-1 border-0 bg-transparent text-secondary">
                <MoreVertical size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => onEdit(pkg)}>
                  <Pencil size={14} className="me-2" />
                  Edit
                </Dropdown.Item>
                <Dropdown.Item className="text-danger" onClick={() => onDelete(pkg)}>
                  <Trash2 size={14} className="me-2" />
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* Prominent Number of Weddings Callout */}
          <div
            className="qx-wedding-highlight-box p-3 rounded-3 mb-3"
            style={{
              backgroundColor: "#fff5f5",
              border: "1.5px solid #fecdd3",
              boxShadow: "0 1px 3px rgba(166,0,0,0.05)",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: 42,
                  height: 42,
                  backgroundColor: "#A60000",
                  color: "#ffffff",
                  boxShadow: "0 2px 6px rgba(166,0,0,0.25)",
                }}
              >
                <Calendar size={20} />
              </div>
              <div>
                <span
                  className="text-uppercase fw-bold d-block"
                  style={{ fontSize: "0.7rem", color: "#9f1239", letterSpacing: "0.06em" }}
                >
                  Number of Weddings
                </span>
                <span className="fw-extrabold text-dark d-block" style={{ fontSize: "1.4rem", lineHeight: "1.1" }}>
                  {totalWeddings} <span style={{ fontSize: "0.88rem", fontWeight: "600", color: "#475569" }}>{totalWeddings === 1 ? "Wedding" : "Weddings"}</span>
                </span>
              </div>
            </div>
          </div>

          {/* Included Plans & Individual Wedding Limits */}
          <div className="qx-subscription-card__features mb-3">
            <p className="qx-subscription-card__features-title mb-2" style={{ fontSize: "0.75rem", fontWeight: "700", textTransform: "uppercase", color: "#64748b", letterSpacing: "0.04em" }}>
              Included Plans & Wedding Limits
            </p>
            {included.length ? (
              <div className="d-flex flex-column gap-2">
                {included.map((plan, idx) => (
                  <div
                    key={`${plan.displayName}-${idx}`}
                    className="d-flex align-items-center justify-content-between p-2 px-2.5 rounded-2 border"
                    style={{ backgroundColor: "#f8fafc", fontSize: "0.85rem" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <Check size={14} strokeWidth={3} style={{ color: "#A60000" }} />
                      <span className="fw-semibold text-dark">{plan.displayName}</span>
                    </div>
                    <span
                      className="badge px-2.5 py-1 fw-bold"
                      style={{ backgroundColor: "#A60000", color: "#ffffff", fontSize: "0.75rem", borderRadius: "4px" }}
                    >
                      {plan.limitVal} {plan.limitVal === 1 ? "Wedding" : "Weddings"}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="qx-subscription-feature-item--empty mb-0 text-muted small">No plans included</p>
            )}
          </div>
        </div>

        {/* WhatsApp Message Meta */}
        <div className="qx-subscription-card__meta mt-auto pt-2 border-top">
          <div className="qx-subscription-card__meta-item py-2 px-3">
            <span className="qx-subscription-card__meta-icon" style={{ width: 32, height: 32 }}>
              <MessageCircle size={14} />
            </span>
            <div>
              <span className="qx-subscription-card__meta-value" style={{ fontSize: "0.95rem" }}>
                {(pkg?.whatsappMessageLimit ?? 0).toLocaleString("en-IN")}
              </span>
              <span className="qx-subscription-card__meta-label" style={{ fontSize: "0.75rem" }}>WhatsApp messages</span>
            </div>
          </div>
        </div>
      </article>
    </div>
  );
};

const WhatsAppPackageCard = ({ pkg, onEdit, onDelete }) => {
  const messageLimit =
    pkg?.messagesLimit ?? pkg?.messageLimit ?? pkg?.whatsappMessageLimit ?? 0;

  return (
    <div className="col-lg-4 col-md-6 d-flex">
      <article className="qx-subscription-card qx-whatsapp-package-card flex-fill d-flex flex-column justify-content-between p-3.5" style={{ borderRadius: "14px", border: "1px solid #e2e8f0", backgroundColor: "#ffffff" }}>
        <div>
          <div className="qx-subscription-card__header pb-3 mb-3 border-bottom d-flex align-items-start justify-content-between">
            <div className="qx-subscription-card__title-wrap">

              <h3 className="qx-subscription-card__name mb-1.5" style={{ fontSize: "1.15rem", fontWeight: "700", color: "#0f172a" }}>{pkg?.name || "Untitled"}</h3>
              <div className="d-flex align-items-center gap-2">
                <span
                  className="badge  border px-2.5 py-1.5 fw-bold"
                  style={{ fontSize: "0.82rem", borderRadius: "6px", color: "#334155", backgroundColor: "#f8fafc" }}
                >
                  ₹{formatCurrency(pkg?.price)}
                </span>
              </div>
            </div>
            <Dropdown align="end">
              <Dropdown.Toggle variant="" className="qx-action-toggle i-false p-1 border-0 bg-transparent text-secondary">
                <MoreVertical size={16} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => onEdit(pkg)}>
                  <Pencil size={14} className="me-2" />
                  Edit
                </Dropdown.Item>
                <Dropdown.Item className="text-danger" onClick={() => onDelete(pkg)}>
                  <Trash2 size={14} className="me-2" />
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="qx-subscription-card__meta mt-2">
          <div className="qx-subscription-card__meta-item py-2 px-3">
            <span className="qx-subscription-card__meta-icon">
              <MessageCircle size={16} />
            </span>
            <div>
              <span className="qx-subscription-card__meta-value">
                {Number(messageLimit).toLocaleString("en-IN")}
              </span>
              <span className="qx-subscription-card__meta-label">Message limit</span>
            </div>
          </div>
        </div>
      </article>
    </div>
  );
};



const Subscriptions = () => {
  // ---- Static Subscription Data ----
  const [subscriptions, setSubscriptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("package");
  const [planRequests, setPlanRequests] = useState([]);
  const [requestLoader, setRequestLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [plans, setPlans] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const navigate = useNavigate();

  const [partnerPackagesList, setPartnerPackagesList] = useState([]);
  const [combinationPackagesList, setCombinationPackagesList] = useState([]);
  const [subscriptionPlansList, setSubscriptionPlansList] = useState([]);

  const fetchSubscriptionPlans = async () => {
    try {
      const res = await getSUBSCRIPTION();
      const data = res?.data?.data || res?.data || [];
      if (Array.isArray(data)) setSubscriptionPlansList(data);
    } catch (err) {
      console.error("Error fetching getSUBSCRIPTION:", err);
    }
  };

  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);

  const fetchSubscription = async (isCombined = activeTab === "combination") => {
    try {
      setLoader(true);
      if (isCombined) {
        const res = await getPackage(true);
        const data = res?.data?.data || res?.data || [];
        setCombinationPackagesList(Array.isArray(data) ? data : []);
      } else {
        const res = await getPackage(false);
        const data = res?.data?.data || res?.data || [];
        setPartnerPackagesList(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.error("Error fetching Package:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (activeTab === "package") {
      fetchSubscription(false);
    } else if (activeTab === "combination") {
      fetchSubscription(true);
      if (partnerPackagesList.length === 0) {
        getPackage(false)
          .then((res) => {
            const data = res?.data?.data || res?.data || [];
            if (Array.isArray(data)) setPartnerPackagesList(data);
          })
          .catch(console.error);
      }
    } else if (activeTab === "whatsapp") {
      fetchWhatsAppPackages();
    }
  }, [activeTab]);

  // Example API call
  const fetchPlanRequests = async () => {
    try {
      setRequestLoader(true);
      const res = await getNEWUSERS(
        currentPage,
        itemsPerPage,
        debouncedSearch,
        "updatePlan",
        filterDate,
        endDate,
      );

      setPlanRequests(res?.data?.data?.users);
      setTotalItems(res?.data?.data?.count || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setRequestLoader(false);
    }
  };


  useEffect(() => {
    if (activeTab === "requests") {
      setCurrentPage(0); // Reset to first page on tab change
      setSearch(""); // Clear search on tab change
      fetchPlanRequests();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "requests") {
      fetchPlanRequests();
    }



  }, [currentPage, debouncedSearch, filterDate, endDate]);

  const debouncedHandler = useMemo(
    () =>
      debounce((value) => {
        // 🔥 hit API only if 3+ chars OR empty (for reset)
        if (value.length >= 1 || value.length === 0) {
          setDebouncedSearch(value);
          setCurrentPage(0); // reset pagination
        }
      }, 800),
    [],
  );

  useEffect(() => {
    if (activeTab === "requests") {
      setCurrentPage(0); // Reset to first page on search change
      fetchPlanRequests();
    }
  }, [debouncedSearch, filterDate, endDate]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedItemToReject, setSelectedItemToReject] = useState(null);
  const handleCloseRejectModal = () => {
    setShowRejectModal(false);
    setSelectedItemToReject(null);
  };

  const handleOpenRejectModal = (item) => {
    setSelectedItemToReject(item);
    setShowRejectModal(true);
  };
  const handleConfirmReject = () => {
    if (selectedItemToReject) {
      deleteRequestUserPlan(selectedItemToReject._id)
        .then(() => {
          toast.success("Request rejected");
          fetchPlanRequests();
          handleCloseRejectModal(); // Close the modal on success
        })
        .catch((error) => {
          // Optional: Handle error
          toast.error("Failed to reject plan");
          handleCloseRejectModal();
        });
    }
  };
  const renderPlanRequestTable = (data) => (
    <>
      <Card>
        <Card.Body>
          <Table responsive>
            <thead style={{ color: "#A60000" }}>
              <tr>
                <th>
                  <strong>S.NO</strong>
                </th>
                <th>
                  <strong>Name</strong>
                </th>

                <th>
                  <strong>Phone</strong>
                </th>
                <th>
                  <strong>Current Plan</strong>
                </th>

                <th>
                  <strong>Request Date</strong>
                </th>

                <th>
                  <strong>Action</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item?._id} style={{ color: "#A60000" }}>
                  <td>{index + 1}</td>
                  <td
                    className="text-blue cursor-pointer"
                    onClick={() => navigate(`/user-details/${item?._id}`)}
                  >
                    {item?.hostName}
                  </td>

                  <td>
                    {item?.countryCode} {item?.phoneNumber}
                  </td>
                  <td>
                    <Badge bg="" className="badge-success">
                      {item?.plan?.name}
                    </Badge>
                  </td>

                  <td>
                    {item.upgradePlanRequestDate
                      ? new Date(
                        item.upgradePlanRequestDate,
                      ).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                      : "_"}
                  </td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="info light"
                        className="light sharp btn btn-info i-false"
                      >
                        {svg1}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleModalShow(item)}>
                          Change Plan
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleOpenRejectModal(item)}
                        >
                          Reject
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <Modal show={showRejectModal} onHide={handleCloseRejectModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Rejection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to reject the plan upgrade request for{" "}
          <strong>{selectedItemToReject?.hostName}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRejectModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmReject}>
            Yes, Reject Plan
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const defaultWhatsAppPackages = [
    {
      _id: "wa-1",
      name: "Basic WhatsApp Booster",
      price: "999",
      whatsappMessageLimit: 5000,
      messageLimit: 5000,
      isWhatsApp: true,
    },
    {
      _id: "wa-2",
      name: "Standard WhatsApp Pack",
      price: "1999",
      whatsappMessageLimit: 15000,
      messageLimit: 15000,
      isWhatsApp: true,
    },
    {
      _id: "wa-3",
      name: "Enterprise WhatsApp Pack",
      price: "4999",
      whatsappMessageLimit: 50000,
      messageLimit: 50000,
      isWhatsApp: true,
    },
  ];

  const [whatsappPackagesList, setWhatsappPackagesList] = useState([]);

  const fetchWhatsAppPackages = async () => {
    try {
      setLoader(true);
      const res = await getWhatsAppPackage();
      const resData = res?.data?.data || res?.data || {};
      const plansList = resData?.plans || resData?.docs || resData?.list || (Array.isArray(resData) ? resData : []);
      setWhatsappPackagesList(Array.isArray(plansList) ? plansList : []);
    } catch (err) {
      console.error("Error fetching WhatsApp packages:", err);
    } finally {
      setLoader(false);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCombinationModal, setIsCombinationModal] = useState(false);
  const [isWhatsAppModal, setIsWhatsAppModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [reqModalShow, setReqModalShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSubId, setDeleteSubId] = useState(null);

  const handleConfirmDelete = async () => {
    if (!deleteSubId) return;
    if (activeTab === "whatsapp" || isWhatsAppModal || String(deleteSubId).startsWith("wa-")) {
      try {
        await deleteWhatsAppPackage(deleteSubId);
        toast.success("WhatsApp package deleted successfully");
        fetchWhatsAppPackages();
      } catch (error) {
        console.error("Error deleting WhatsApp package:", error);
        toast.error(error?.response?.data?.message || "Failed to delete WhatsApp package");
      } finally {
        setShowDeleteModal(false);
        setDeleteSubId(null);
      }
      return;
    }
    try {
      await deleteSUBSCRIPTION(deleteSubId);
      toast.success("Package deleted successfully");
      fetchSubscription();
    } catch (error) {
      console.error("Error deleting Package:", error);
      toast.error(error?.response?.data?.message || "Failed to delete Package");
    } finally {
      setShowDeleteModal(false);
      setDeleteSubId(null);
    }
  };

  // ---- Yup Validation Schema ----
  const positiveNumberString = Yup.string()
    .required("Required")
    .matches(/^\d+(\.\d+)?$/, "Only numbers and one dot allowed")
    .test(
      "not-negative",
      "Value cannot be negative",
      (value) => value !== undefined && Number(value) >= 0,
    );

  const validationSchema = Yup.object({
    name: Yup.string().trim().required("Package name is required"),
    price: positiveNumberString,
    messageLimit: isWhatsAppModal
      ? Yup.number()
        .typeError("Message limit must be a number")
        .required("Message limit is required")
        .min(1, "Message limit must be greater than 0")
      : Yup.number().notRequired(),
    whatsappMessageLimit: Yup.number().notRequired(),
    totalHostLimit: Yup.number().notRequired(),
    strikeOut: Yup.string().notRequired(),
    combinedPackages: isWhatsAppModal
      ? Yup.array()
      : isCombinationModal
        ? Yup.array()
          .min(1, "At least one partner package must be selected")
          .of(
            Yup.object({
              packageId: Yup.string().required("Package is required"),
              hostLimit: Yup.number()
                .typeError("Host limit must be a number")
                .min(1, "Host limit must be at least 1")
                .max(1000, "Host limit for each plan cannot exceed 1000"),
            })
          )
        : Yup.array()
          .test(
            "at-least-one-plan-selected",
            "At least one plan must have a host limit greater than 0",
            (value) => {
              if (!value || !Array.isArray(value)) return false;
              return value.some((item) => Number(item?.hostLimit || 0) > 0);
            }
          )
          .of(
            Yup.object({
              hostLimit: Yup.number()
                .typeError("Host limit must be a number")
                .min(0, "Host limit cannot be negative")
                .max(1000, "Host limit for each plan cannot exceed 1000"),
            })
          ),
    features: Yup.array().notRequired(),
  });
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // ---- Open Modal for Add/Edit ----
  const handleShowModal = async (sub = null, isCombo = false, isWa = false) => {
    setEditMode(!!sub);
    setSelectedSub(sub);
    const targetIsWa = isWa || (activeTab === "whatsapp" && !sub) || Boolean(sub?.isWhatsApp);
    const targetIsCombo = !targetIsWa && (isCombo || Boolean(sub?.isCombination));
    setIsWhatsAppModal(targetIsWa);
    setIsCombinationModal(targetIsCombo);
    if (!targetIsWa && !targetIsCombo) {
      fetchSubscriptionPlans();
    }
    if (targetIsCombo && partnerPackagesList.length === 0) {
      try {
        const res = await getPackage(false);
        const data = res?.data?.data || res?.data || [];
        if (Array.isArray(data)) setPartnerPackagesList(data);
      } catch (e) {
        console.error(e);
      }
    }
    setShowModal(true);
  };

  // ---- Handle Add/Edit Submit ----
  const handleSubmit = async (values, { resetForm }) => {
    try {
      if (isWhatsAppModal) {
        const limitVal = Number(values.messageLimit || values.messagesLimit || values.whatsappMessageLimit) || 0;
        if (editMode) {
          const waId = selectedSub?._id || selectedSub?.id || selectedSub?.whatsappPlanId;
          const payload = {
            whatsappPlanId: waId,
            name: values.name,
            price: String(values.price),
            messagesLimit: limitVal,
          };
          await putWhatsAppPackage(payload);
          toast.success("WhatsApp package updated successfully");
        } else {
          // Do NOT send whatsappPlanId on creation
          const payload = {
            name: values.name,
            price: String(values.price),
            messagesLimit: limitVal,
          };
          await postWhatsAppPackage(payload);
          toast.success("WhatsApp package added successfully");
        }
        fetchWhatsAppPackages();
        resetForm();
        setShowModal(false);
        return;
      }

      if (editMode) {
        if (isCombinationModal) {
          // Payload for Combination Package (Edit)
          const combinationPayload = {
            subscriptionId: selectedSub?._id,
            name: values.name,
            price: String(values.price),
            whatsappMessageLimit: Number(values.whatsappMessageLimit) || 0,
            combinedPackages: (values.combinedPackages || []).map((cp) => ({
              packageId: cp.packageId,
              hostLimit: Number(cp.hostLimit) || 1,
            })),
          };
          await putCombinedPackage(combinationPayload);
          toast.success("Combination package updated successfully");
        } else {
          // Payload for Partner Package (Edit)
          const plans = (subscriptionPlansList || []).map((plan) => {
            const planId = plan._id || plan.id;
            const currentEntry = (values.combinedPackages || []).find((cp) => {
              const pid = typeof cp.packageId === "object" && cp.packageId !== null ? cp.packageId._id || cp.packageId.id : cp.packageId;
              return pid === planId || pid === plan.name;
            });
            return {
              planId: planId,
              hostLimit: Number(currentEntry?.hostLimit ?? 0),
            };
          });

          const activePlans = plans.filter((p) => p.hostLimit > 0);
          if (activePlans.length === 0) {
            toast.error("At least one plan must have a host limit greater than 0");
            return;
          }

          const partnerPayload = {
            subscriptionId: selectedSub?._id,
            name: values.name,
            price: String(values.price),
            plans: plans,
          };
          await updatetSUBSCRIPTION(partnerPayload);
          toast.success("Package updated successfully");
        }
      } else {
        if (isCombinationModal) {
          // Payload for Combination Package (Add)
          const combinationPayload = {
            name: values.name,
            price: String(values.price),
            whatsappMessageLimit: Number(values.whatsappMessageLimit) || 0,
            combinedPackages: (values.combinedPackages || []).map((cp) => ({
              packageId: cp.planId?._id,
              hostLimit: Number(cp.hostLimit) || 1,
            })),
          };
          await postCombinedPackage(combinationPayload);
          toast.success("Combined package added successfully");
        } else {
          const plans = (subscriptionPlansList || []).map((plan) => {
            const planId = plan._id || plan.id;
            const currentEntry = (values.combinedPackages || []).find((cp) => {
              const pid = typeof cp.packageId === "object" && cp.packageId !== null ? cp.packageId._id || cp.packageId.id : cp.packageId;
              return pid === planId || pid === plan.name;
            });
            return {
              planId: planId,
              hostLimit: Number(currentEntry?.hostLimit ?? 0),
            };
          });

          const activePlans = plans.filter((p) => p.hostLimit > 0);
          if (activePlans.length === 0) {
            toast.error("At least one plan must have a host limit greater than 0");
            return;
          }

          const partnerPayload = {
            name: values.name,
            price: String(values.price),
            plans: plans,
          };
          await postSUBSCRIPTION(partnerPayload);
          toast.success("Package added successfully");
        }
      }
      resetForm();
      setShowModal(false);
      fetchSubscription();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Operation failed");
    }
  };

  const handleModalShow = (item) => {
    setSelectedRequest(item);
    setReqModalShow(true);
  };

  if (loader) {
    return (
      <div className="qx-page">
        <PageContentLoader message="Loading packages..." />
      </div>
    );
  }

  const addButtonLabel =
    activeTab === "combination"
      ? "Add Combined Package"
      : activeTab === "whatsapp"
        ? "Add WhatsApp Package"
        : "Add Package";

  return (
    <div className="qx-page qx-content-page qx-subscription-page qx-packages-page">
      <PageTitle
        pageTitle="Packages"
        subtitle="Manage partner packages and WhatsApp message packs"
        actions={
          <Button
            className="maroon-btn"
            onClick={() =>
              handleShowModal(null, activeTab === "combination", activeTab === "whatsapp")
            }
          >
            + {addButtonLabel}
          </Button>
        }
      />

      <div className="qx-seg-tabs mb-4" role="tablist">
        <button
          type="button"
          className={`qx-seg-tab ${activeTab === "package" ? "qx-seg-tab--active" : ""}`}
          onClick={() => setActiveTab("package")}
        >
          Partner Packages
        </button>
        <button
          type="button"
          className={`qx-seg-tab ${activeTab === "whatsapp" ? "qx-seg-tab--active" : ""}`}
          onClick={() => setActiveTab("whatsapp")}
        >
          WhatsApp Package
        </button>
      </div>

      {activeTab === "package" ? (
        partnerPackagesList?.length > 0 ? (
          <div className="row g-4 align-items-stretch qx-subscription-grid">
            {partnerPackagesList.map((s, i) => (
              <PartnerPackageCard
                key={s._id || i}
                pkg={s}
                subscriptionPlansList={subscriptionPlansList}
                onEdit={(pkg) => handleShowModal(pkg, false, false)}
                onDelete={(pkg) => {
                  setDeleteSubId(pkg._id);
                  setShowDeleteModal(true);
                }}
              />
            ))}
          </div>
        ) : (
          <div className="qx-empty-state qx-empty-state--rich">
            <div className="qx-empty-state__icon">
              <PackageIcon size={28} />
            </div>
            <p className="qx-empty-state__title">No partner packages yet</p>
            <p className="qx-empty-state__desc mb-0">
              Create your first partner package to get started.
            </p>
          </div>
        )
      ) : whatsappPackagesList?.length > 0 ? (
        <div className="row g-4 align-items-stretch qx-subscription-grid">
          {whatsappPackagesList.map((s, i) => (
            <WhatsAppPackageCard
              key={s._id || i}
              pkg={s}
              onEdit={(pkg) => handleShowModal(pkg, false, true)}
              onDelete={(pkg) => {
                setDeleteSubId(pkg._id);
                setShowDeleteModal(true);
              }}
            />
          ))}
        </div>
      ) : (
        <div className="qx-empty-state qx-empty-state--rich">
          <div className="qx-empty-state__icon">
            <MessageCircle size={28} />
          </div>
          <p className="qx-empty-state__title">No WhatsApp packages yet</p>
          <p className="qx-empty-state__desc mb-0">
            Add a WhatsApp message pack for partners to purchase.
          </p>
        </div>
      )}

      {/* ---- Add/Edit Modal ---- */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        size="xl"
        className="qx-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editMode
              ? isWhatsAppModal
                ? "Edit WhatsApp Package"
                : isCombinationModal
                  ? "Edit Combined Package"
                  : "Edit Package"
              : isWhatsAppModal
                ? "Add WhatsApp Package"
                : isCombinationModal
                  ? "Add Combined Package"
                  : "Add Package"}
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            name: selectedSub?.name || "",
            planId: selectedSub?.planId || selectedSub?.plan?._id || selectedSub?.subscriptionId || "",
            price: selectedSub?.price || "",
            messageLimit: selectedSub?.messagesLimit || selectedSub?.messageLimit || selectedSub?.whatsappMessageLimit || "",
            features: selectedSub?.features || [],
            strikeOut: selectedSub?.strikeOut || "",
            whatsappMessageLimit: selectedSub?.whatsappMessageLimit || "",
            totalHostLimit: selectedSub?.totalHostLimit || "",
            combinedPackages: isCombinationModal
              ? selectedSub?.combinedPackages || []
              : subscriptionPlansList && subscriptionPlansList.length > 0
                ? subscriptionPlansList.map((plan, idx) => {
                  const planId = plan._id || plan.id;
                  const subList = selectedSub?.combinedPackages || selectedSub?.plans || [];
                  const matched = subList.find((cp) => {
                    const cpId = (typeof cp.planId === "object" ? cp.planId?._id : cp.planId) ||
                      (typeof cp.packageId === "object" ? cp.packageId?._id : cp.packageId) ||
                      cp._id;
                    return cpId === planId;
                  }) || subList[idx];

                  return {
                    packageId: planId,
                    hostLimit: matched?.hostLimit !== undefined && matched?.hostLimit !== null ? matched.hostLimit : 0,
                  };
                })
                : [],
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <FormikForm>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#A60000" }}>
                    Package Name *
                  </Form.Label>
                  <Field
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter package name"
                    style={{ borderColor: "#A60000" }}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger small"
                  />
                </Form.Group>

                {!isCombinationModal && !isWhatsAppModal && (
                  <>

                    {subscriptionPlansList && subscriptionPlansList.length > 0 && (
                      <div
                        className="mb-3 p-3 border rounded"
                        style={{
                          borderColor: "#A60000",
                          backgroundColor: "#ffff",
                          borderRadius: "0.75rem",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="fw-bold mb-0" style={{ color: "#A60000" }}>
                            All Subscription Plans & Host Limits *
                          </h6>
                          <span className="text-muted small" style={{ fontSize: "0.75rem" }}>
                            Host Limit for each plan: 0 to 1000
                          </span>
                        </div>

                        {subscriptionPlansList.map((plan, idx) => {
                          const planId = plan._id || plan.id;
                          const planName = plan.name || "Plan";
                          const planPrice = plan.price ? `₹${plan.price}` : "";
                          const planWaLimit = Number(plan.whatsappMessageLimit || plan.messageLimit || 0);

                          const currentEntry = (values.combinedPackages || []).find((cp, cpIdx) => {
                            const pid = (typeof cp.packageId === "object" ? cp.packageId?._id : cp.packageId) ||
                              (typeof cp.planId === "object" ? cp.planId?._id : cp.planId) ||
                              cp._id;
                            return pid === planId || pid === plan.name || cpIdx === idx;
                          });

                          const hostLimitVal = currentEntry ? currentEntry.hostLimit : 0;
                          const numLimit = Number(hostLimitVal || 0);
                          const calcWa = planWaLimit * numLimit;

                          return (
                            <Row key={planId || idx} className="align-items-center mb-3 pb-2 border-bottom">
                              <Col md={5}>
                                <span className="fw-semibold text-dark d-block">
                                  {planName} {planPrice ? `(${planPrice})` : ""}
                                </span>
                                {planWaLimit > 0 && (
                                  <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                    Base Msg Limit: {planWaLimit.toLocaleString("en-IN")}
                                  </small>
                                )}
                              </Col>
                              <Col md={7}>
                                <div className="d-flex flex-column">
                                  <div className="d-flex align-items-center gap-2">
                                    <Form.Label
                                      className="mb-0 small fw-semibold"
                                      style={{
                                        color: "#A60000",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Host Limit:
                                    </Form.Label>
                                    <input
                                      type="text"
                                      inputMode="numeric"
                                      className="form-control"
                                      placeholder="0"
                                      style={{ borderColor: "#A60000" }}
                                      value={hostLimitVal !== undefined && hostLimitVal !== null ? hostLimitVal : 0}
                                      onChange={(e) => {
                                        let raw = e.target.value.replace(/[^0-9]/g, "");
                                        let val = raw;
                                        if (raw !== "") {
                                          let num = parseInt(raw, 10);
                                          if (isNaN(num) || num < 0) num = 0;
                                          if (num > 1000) num = 1000;
                                          val = num;
                                        }

                                        const existingIndex = (values.combinedPackages || []).findIndex((cp) => {
                                          const pid = cp.planId
                                            ? (typeof cp.planId === "object" && cp.planId !== null ? cp.planId._id || cp.planId.id : cp.planId)
                                            : (typeof cp.packageId === "object" && cp.packageId !== null ? cp.packageId._id || cp.packageId.id : cp.packageId);
                                          return pid === planId || pid === plan.name;
                                        });

                                        let updated = [...(values.combinedPackages || [])];
                                        if (existingIndex > -1) {
                                          updated[existingIndex] = {
                                            ...updated[existingIndex],
                                            packageId: planId,
                                            hostLimit: val,
                                          };
                                        } else {
                                          updated.push({
                                            packageId: planId,
                                            hostLimit: val,
                                          });
                                        }
                                        setFieldValue("combinedPackages", updated);
                                      }}
                                    />
                                  </div>
                                  {calcWa > 0 && (
                                    <div className="mt-1 small fw-bold" style={{ color: "#A60100", fontSize: "0.78rem" }}>
                                      WhatsApp Msg Limit: {calcWa.toLocaleString("en-IN")} ({planWaLimit.toLocaleString("en-IN")} × {numLimit})
                                    </div>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                      </div>
                    )}
                    <ErrorMessage
                      name="combinedPackages"
                      render={(msg) =>
                        typeof msg === "string" ? (
                          <div className="text-danger small fw-bold mb-3 ms-1">{msg}</div>
                        ) : null
                      }
                    />
                  </>
                )}



                {isWhatsAppModal && (
                  <Form.Group className="mb-3">
                    <Form.Label style={{ color: "#A60000" }}>
                      Message Limit *
                    </Form.Label>
                    <Field name="messageLimit">
                      {({ field, form }) => (
                        <input
                          {...field}
                          type="text"
                          className="form-control"
                          placeholder="Enter message limit"
                          style={{ borderColor: "#A60000" }}
                          inputMode="numeric"
                          onChange={(e) => {
                            const val = e.target.value.replace(/[^0-9]/g, "");
                            form.setFieldValue("messageLimit", val);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="messageLimit"
                      component="div"
                      className="text-danger small"
                    />
                  </Form.Group>
                )}

                {isCombinationModal && !isWhatsAppModal && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label style={{ color: "#A60000" }}>
                        Whatsapp Message Limit *
                      </Form.Label>
                      <Field name="whatsappMessageLimit">
                        {({ field, form }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            placeholder="Enter whatsapp message limit"
                            style={{ borderColor: "#A60000" }}
                            inputMode="numeric"
                            onChange={(e) => {
                              const val = e.target.value.replace(/[^0-9]/g, "");
                              form.setFieldValue("whatsappMessageLimit", val);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="whatsappMessageLimit"
                        component="div"
                        className="text-danger small"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label style={{ color: "#A60000" }}>
                        Select Partner Packages *
                      </Form.Label>
                      <Field name="combinedPackages">
                        {({ form }) => {
                          const partnerOptions = partnerPackagesList.map(
                            (pkg) => ({
                              label: pkg.name,
                              value: pkg._id || pkg.name,
                            })
                          );

                          const currentSelectedIds = (
                            form.values.combinedPackages || []
                          ).map((cp) => (typeof cp.packageId === "object" && cp.packageId !== null ? cp.packageId._id : cp.packageId));

                          const currentValue = partnerOptions.filter((opt) =>
                            currentSelectedIds.includes(opt.value)
                          );

                          return (
                            <div>
                              <Select
                                isMulti
                                name="combinedPackages"
                                options={partnerOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select partner packages..."
                                value={currentValue}
                                onChange={(selected) => {
                                  const selectedIds = selected
                                    ? selected.map((item) => item.value)
                                    : [];
                                  const updatedCombined = selectedIds.map(
                                    (id) => {
                                      const existing = (
                                        form.values.combinedPackages || []
                                      ).find((cp) => {
                                        const pid = typeof cp.packageId === "object" && cp.packageId !== null ? cp.packageId._id : cp.packageId;
                                        return pid === id;
                                      });
                                      return (
                                        existing || {
                                          packageId: id,
                                          hostLimit: "",
                                        }
                                      );
                                    }
                                  );
                                  form.setFieldValue(
                                    "combinedPackages",
                                    updatedCombined
                                  );
                                }}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderColor: "#A60000",
                                  }),
                                }}
                              />

                              <ErrorMessage
                                name="combinedPackages"
                                render={(msg) =>
                                  typeof msg === "string" ? (
                                    <div className="text-danger small">{msg}</div>
                                  ) : null
                                }
                              />
                            </div>
                          );
                        }}
                      </Field>
                    </Form.Group>

                    {values.combinedPackages &&
                      values.combinedPackages.length > 0 && (
                        <div
                          className="mb-3 p-3 border rounded"
                          style={{
                            borderColor: "#A60000",
                            backgroundColor: "#fff5f5",
                          }}
                        >
                          <h6
                            className="fw-bold mb-3"
                            style={{ color: "#A60000" }}
                          >
                            Host Limit for Each Selected Package
                          </h6>
                          {values.combinedPackages.map((cp, idx) => {
                            const targetId = typeof cp.packageId === "object" && cp.packageId !== null ? cp.packageId._id : cp.packageId;
                            const pkgInfo = partnerPackagesList.find(
                              (p) =>
                                p._id === targetId ||
                                p.name === targetId
                            );
                            const pkgName = (typeof cp.packageId === "object" && cp.packageId?.name)
                              ? cp.packageId.name
                              : (pkgInfo?.name || targetId);
                            return (
                              <Row key={idx} className="align-items-start mb-3">
                                <Col md={5}>
                                  <span className="fw-semibold text-dark">
                                    {pkgName}
                                  </span>
                                </Col>
                                <Col md={7}>
                                  <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center gap-2">
                                      <Form.Label
                                        className="mb-0 small fw-semibold"
                                        style={{
                                          color: "#A60000",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Host Limit:
                                      </Form.Label>
                                      <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control"
                                        placeholder="Enter limit"
                                        style={{ borderColor: "#A60000" }}
                                        value={cp.hostLimit}
                                        onChange={(e) => {
                                          const val = e.target.value.replace(/[^0-9]/g, "");
                                          const updated = [
                                            ...values.combinedPackages,
                                          ];
                                          updated[idx] = {
                                            ...updated[idx],
                                            hostLimit: val,
                                          };
                                          setFieldValue(
                                            "combinedPackages",
                                            updated
                                          );
                                        }}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name={`combinedPackages.${idx}.hostLimit`}
                                      render={(msg) =>
                                        typeof msg === "string" ? (
                                          <div className="text-danger small mt-1 ms-5">{msg}</div>
                                        ) : null
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                            );
                          })}
                        </div>
                      )}
                  </>
                )}

                <Form.Group className="mb-3">
                  <Form.Label style={{ color: "#A60000" }}>
                    Total Price *
                  </Form.Label>
                  <Field name="price">
                    {({ field, form }) => (
                      <div style={{ position: "relative" }}>
                   

                        <input
                          {...field}
                          type="text"
                          className="form-control"
                          placeholder="Enter price"
                          style={{
                            borderColor: "#A60000",
                            paddingLeft: "28px",
                          }}
                          inputMode="decimal"
                          onChange={(e) => {
                            let value = e.target.value;

                            value = value.replace(/[^0-9.]/g, "");

                            const parts = value.split(".");
                            if (parts.length > 2) {
                              value = parts[0] + "." + parts.slice(1).join("");
                            }

                            form.setFieldValue("price", value);
                          }}
                        />
                      </div>
                    )}
                  </Field>

                  <ErrorMessage
                    name="price"
                    component="div"
                    className="text-danger small"
                  />
                </Form.Group>


              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button   type="submit" disabled={isSubmitting}>
                  {editMode ? "Update" : "Add"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      <Modal show={reqModalShow} onHide={() => setReqModalShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Plan</Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            planId: selectedRequest?.plan?.id || "",
            userId: selectedRequest?._id,
          }}
          onSubmit={async (values) => {
            try {
              const payload = {
                userId: values.userId,
                subscriptionId: values.planId,
              };
              await changeRequestUserPlan(payload);
              toast.success("Plan updated");
              fetchPlanRequests();
              setReqModalShow(false);
            } catch (error) {
              console.error(error);
            }
          }}
        >
          {({ handleSubmit, values, handleChange, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Select New Plan</Form.Label>

                  <Form.Select
                    name="planId"
                    value={values.planId}
                    onChange={handleChange}
                    isInvalid={touched.planId && !!errors.planId}
                  >
                    {subscriptions?.map((plan) => (
                      <option key={plan._id} value={plan._id}>
                        {plan?.name}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Control.Feedback type="invalid">
                    {errors.planId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setReqModalShow(false)}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#a70000",
                    borderColor: "#a70000",
                    fontWeight: "600",
                  }}
                >
                  Save Changes
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>


      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#A60000" }}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this package plan? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Subscriptions;
